var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('Headline',{attrs:{"instrument":_vm.instrument},model:{value:(_vm.highlight),callback:function ($$v) {_vm.highlight=$$v},expression:"highlight"}})],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }